import format from 'date-fns/format';
import React, { useState } from 'react';

import { AppointmentTag } from '@eluve/blocks';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  NewButton,
  Paragraph,
  VStack,
} from '@eluve/components';

export interface FileTag {
  tagName: string;
  metadata: any;
  createdAt: string;
  isSystem: boolean;
}

export interface FileTagsDialogProps {
  tags: FileTag[];
}

export const FileTagsDialog: React.FC<FileTagsDialogProps> = ({ tags }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <NewButton
          icon={{ name: 'Tag' }}
          type="outline"
          text={`${tags.length}`}
          disabled={tags.length === 0}
        />
      </DialogTrigger>
      <DialogContent className="max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>File Tags ({tags.length})</DialogTitle>
        </DialogHeader>
        <VStack gap={3}>
          {tags.length === 0 ? (
            <Paragraph size="sm">No tags</Paragraph>
          ) : (
            tags.map((tag, index) => (
              <div
                key={`${tag.tagName}-${index}`}
                className="w-full rounded-md border p-3"
              >
                <VStack>
                  <AppointmentTag
                    tag={{
                      id: tag.tagName,
                      tag: tag.tagName,
                      isSystemTag: tag.isSystem,
                    }}
                  />
                  <Paragraph size="sm" className="ml-2">
                    {format(new Date(tag.createdAt), 'MMM d, yyyy h:mm a')}
                  </Paragraph>
                </VStack>
                {tag.metadata && Object.keys(tag.metadata).length > 0 && (
                  <pre className="mt-2 overflow-x-auto rounded bg-bg-gray-subtle p-2 text-xs">
                    {JSON.stringify(tag.metadata, null, 2)}
                  </pre>
                )}
              </div>
            ))
          )}
        </VStack>
      </DialogContent>
    </Dialog>
  );
};
